module.exports = __webpack_public_path__ + "img/greenhouse-sankey.97a7d440.png";